import React, { FC } from 'react';

import { BUTTON_TYPES } from '@evinced-private/ui-common';

import { PropertyHelper } from '../../../helpers/PropertyHelper';
import { IProperty } from '../../../interfaces/Property';
import { useConfiguration } from '../../../providers/configurationProvider/ConfigurationProvider';
import { SiteScannerUiToggles } from '../../../services/LocalTogglesService';
import { CreatePropertyFromJsonPopup } from '../../create-property/CreatePropertyFromJsonPopup';
import { EditPropertyPopup } from '../../edit-property/EditPropertyPopup';

import './PropertyJsonEditor.scss';

interface IPropertySettingsTitleProps {
	propertyId: string;
	goToProperty: (propertyId: string) => void;
	editProperty: (propertyForSave: IProperty, shouldCrawl: boolean) => void;
}

export const PropertyJsonEditor: FC<IPropertySettingsTitleProps> = ({
	propertyId,
	goToProperty,
	editProperty
}: IPropertySettingsTitleProps) => {
	const { getToggle } = useConfiguration();
	const showPropertyJsonConfig = getToggle(SiteScannerUiToggles.ENABLE_PROPERTIES_JSON_EDITOR);

	if (!showPropertyJsonConfig) {
		return null;
	}
	if (PropertyHelper.isPropertyInDraftMode(propertyId)) {
		return (
			<div className="json-button-container">
				<CreatePropertyFromJsonPopup
					triggerButtonProps={{
						type: BUTTON_TYPES.ACTION,
						title: 'Create from JSON',
						children: 'Create from JSON',
						className: 'json-config'
					}}
					onPropertyCreated={goToProperty}
				/>
			</div>
		);
	}
	return (
		<EditPropertyPopup
			propertyId={propertyId}
			triggerButtonProps={{
				type: BUTTON_TYPES.ACTION,
				title: 'JSON Editor',
				children: 'JSON Editor',
				className: 'json-config'
			}}
			onSaveChanges={(propertyToSave) => {
				editProperty(propertyToSave, false);
			}}
		/>
	);
};
